import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EdiRespondeOrder } from '../../../models/edi';
import { EdiRespondeOrderResponseActionConfigService } from '../../../services/edi-order-response-action-config/edi-order-response-action-config.service';
import { EdiOrderResponseDetailConfigService } from '../../../services/edi-order-response-detail-config/edi-order-response-detail-config.service';
import { EdiService } from '../../../services/edi/edi.service';
import { EdiNavigationService } from '../../../services/edi/edi-navigation.service';
import { EdiRowTable, EdiRowTableType } from '../edi-row-table/edi-row-table.component';
import { DateUtilService } from 'gung-common';
import { BackendFeatureService } from '../../../services/backend-feature.service';
import { EDI_VIEWER_FEATURE_ID } from '../../../services/edi/edi-viewer-compatibility.service';

@Component({
    selector: 'lib-edi-order-response-detail',
    templateUrl: './edi-order-response-detail.component.html',
    styleUrls: ['./edi-order-response-detail.component.css'],
    standalone: false
})
export class EdiOrderResponseDetailComponent implements OnInit {
  protected route = inject(ActivatedRoute);
  protected router = inject(Router);
  protected ediService = inject(EdiService);
  public ediNavigationService = inject(EdiNavigationService);
  public configService = inject(EdiOrderResponseDetailConfigService);
  public actionConfig = inject(EdiRespondeOrderResponseActionConfigService);
  public dateUtilService = inject(DateUtilService);
  protected backendFeatureService = inject(BackendFeatureService);
  documentViewerEnabled$ = this.backendFeatureService.isActivated(EDI_VIEWER_FEATURE_ID);
  
  orderResponseId: string;
  orderResponseData: any;
  orderId: string;
  ediNavigationBaseRoute: string;
  itemsColumns: EdiRowTable[] = [
    {
      header: 'IMAGE',
      type: EdiRowTableType.IMAGE,
      getValue: (item: EdiRespondeOrder) => item?.extra?.images
    },
    {
      header: 'ID',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiRespondeOrder) => item.ids?.gungId
    },{
      header: 'EXPECTED_QUANTITY',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiRespondeOrder) => item.quantities?.expectedQuantity
    },
    {
      header: 'ACTUAL_QUANTITY',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiRespondeOrder) => item.quantities?.actualQuantity
    },
    {
      header: 'UNIT_NET_PRICE',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiRespondeOrder) =>
        (item.prices?.actualUnitNetPrice?.value || '') + ' ' + (item.prices?.actualUnitNetPrice?.currency || '')
    },
    {
      header: 'UNIT_GROSS_PRICE',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiRespondeOrder) =>
        (item.prices?.actualUnitGrossPrice?.value || '') + ' ' + (item.prices?.actualUnitGrossPrice?.currency || '')
    },
    {
      header: 'DELIVERY_DATE',
      type: EdiRowTableType.DATE,
      getValue: (item: EdiRespondeOrder) => item.deliveryDate
    },
    {
      header: 'TOTAL_NET_PRICE',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiRespondeOrder) =>
        (item.prices?.actualTotalNetPrice?.value || '') + ' ' + (item.prices?.actualTotalNetPrice?.currency || '')
    }
  ];

  ngOnInit(): void {
    this.route.params.subscribe(data => {
      this.orderResponseId = data.id;

      const urlSegments = this.router.url.split('?')[0].split('/');
      this.ediNavigationBaseRoute = urlSegments.slice(0, -1).join('/');
      this.ediNavigationService.setNavigationCurrentId(this.ediNavigationBaseRoute, this.orderResponseId);

      this.ediService.getOrderResponse(this.orderResponseId).subscribe(orderResponseData => {
        this.orderResponseData = orderResponseData.data;
      });
    });
  }
}
